export default "__VITE_ASSET__CcpYzk81__"